'use client'

import AiInRecruitingPage from 'components/AiInRecruitingPage'
import PageWrapper from 'components/PageWrapper'
import PAGE_CONSTANT_TEXTS from 'constants/pageMetaTags'

const AiInSecurity = () => (
  <PageWrapper {...PAGE_CONSTANT_TEXTS['ai-in-security']}>
    <AiInRecruitingPage />
  </PageWrapper>
)
export default AiInSecurity
